const Layout = () => import('@/layout/index.vue');

export default {
  path: '/genPage',
  name: 'GenPage',
  component: Layout,
  meta: {
    icon: 'tools',
    title: '页面配置',
    rank: 6,
    permission: ['root']
  },
  children: [
    {
      path: '/genPage/pegeConfig',
      name: 'pegeConfig',
      component: () => import('@/views/genPage/pegeConfig/index.vue'),
      meta: {
        title: '添加页面',
        icon: 'plus'
      }
    }
  ]
};
